import { styled } from 'styled-components';

import { theme } from '../../styles';
import { HelpIllustration } from '../../assets/illustrations';
import { Headings } from '../Headings';
import { Box, Container } from '../Layout';

type FAQStretchedContainerProps = {
  children: React.ReactNode;
};

const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translate(0, -50%);
`;

const Children = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
`;

export const FAQStretchedContainer = ({ children }: FAQStretchedContainerProps) => (
  <Container position="relative" backgroundColor="black05">
    <Box
      data-testid="test-faq-list"
      maxWidth={['100%', 560, 578]}
      paddingTop={40}
      paddingBottom={[160, 140, 200]}
      paddingLeft={[10, 0, 0]}
      paddingRight={[10, 0, 0]}
      marginLeft="auto"
      marginRight="auto"
    >
      <IconWrapper>
        <HelpIllustration title="Vanliga frågor" />
      </IconWrapper>
      <Box textAlign="center">
        <Headings.H3 marginBottom={60}>Vanliga frågor</Headings.H3>
      </Box>
      <Children>{children}</Children>
    </Box>
  </Container>
);
